import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import es from './es.json';
import pt from './pt.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    es: {
      translation: es,
    },
    pt: {
      translation: pt,
    },
  },
  fallbackLng: 'en',

  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
});

export const t = i18n.t.bind(i18n);

export const setLocale = (locale) => {
  i18n.changeLanguage(locale);
};

const fallbackMap = {
  en: 'en-US',
  es: 'es-ES',
  pt: 'pt-PT',
};

export const getLocale = () => {
  const lang = i18n.language || 'en';
  return fallbackMap[lang] || lang;
};
